import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WebAssetIcon(props: IconProps) {
    return <Icon {...props} iconKey={"web_asset"}/>
}
